// Video content plays　on scroll (with sound muted)　and when user clicks on the　video
// it would then open a pop-up window. Within the　pop-up window we could　have a button to take the　video full screen if user　wanted.
// Video should have the ability to play an mp4 video/ youtube video or vimeo video. Also with the ability to play inline

import React from "react"
import ReactDOM from 'react-dom';
import styled from "styled-components"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"
import ReactPlayer from "react-player"
import PlaySvg from "../svg/play"

class Video extends React.Component {
   state = {
      isVideoPoppedUp: false,
      isInlineVideoOnTop: false,
      screenHeight: 0,
      videoLocation: 0,
      videoHeight: 0,
      isInViewport: ''
   }

   componentDidMount = () => {
      if (typeof window !== `undefined`) {
         window.addEventListener("resize", this.updateWindowHeight)
         window.addEventListener("scroll", this.getVideoLocation, false)
      }
      this.updateWindowHeight()
      this.getVideoLocation()
   }

   componentWillUnmount = () => {
      window.removeEventListener('resize', this.getVideoLocation);
      window.removeEventListener('scroll', this.getVideoLocation);
   }

   updateWindowHeight = () => {
      this.setState({
         screenHeight:
            window.innerHeight !== undefined
               ? window.innerHeight
               : document.documentElement || document.body.parentNode || document.body
      })
      this.getVideoLocation()
   }

   getVideoLocation = () => {
      if (this) {
         const n = ReactDOM.findDOMNode(this);
         const videoLocation = n.getBoundingClientRect().top
         const videoHeight = n.offsetHeight
         const isInViewport = videoLocation - (this.state.screenHeight - videoHeight) < 0 &&
            videoLocation - (this.state.screenHeight - videoHeight) + this.state.screenHeight - videoHeight > 0

         this.setState({ isInViewport, videoLocation, videoHeight })
      }
   }

   viewportToPlay = poster => {
      if (poster) {
         poster.click()
         this.setState({ isInlineVideoOnTop: true })
      } else {
         this.setState({ isInlineVideoOnTop: false })
      }
   }

   popUpAndPlay = () => {
      var header = document.querySelector('header');
      header.style.display = 'none';
      this.setState({ isVideoPoppedUp: true })
   }

   fadeAndPause = () => {
      var header = document.querySelector('header');

      header.style.display = 'block';

      this.setState({ isVideoPoppedUp: false })
   }

   clickAndPlay = () => {
      this.setState({ isInlineVideoOnTop: true })
   }

   render() {

      const url = this.props.url
      const poster = this.props.poster
      const playAuto = this.props.playAuto
      const popup = this.props.popup
      const inline = this.props.inline
      const { isVideoPoppedUp, isInlineVideoOnTop, screenHeight, videoLocation, videoHeight, isInViewport } = this.state
      const isVimeo = url !== undefined ? url.match(/vimeo/g) : false
      //console.log(poster);
      //console.log(poster.match(/jpg$|jpeg$|png$/g, poster));

      return (
         <div>
            {popup && (
               <VideoWrapper className='video-wrapper'>
                  {poster.match(/\.(jpg|jpeg|png)/g) ?
                     <Poster onClick={this.popUpAndPlay}>
                        <PlaySvg />
                        <Bg src={poster} alt="poster" />
                     </Poster>
                     : <TextPoster onClick={this.popUpAndPlay}> {poster} </TextPoster>}
                  <VideoPopUp
                     className="popup-wrapper"
                     isVisible={isVideoPoppedUp}
                     onClick={this.fadeAndPause}>
                     <div className="close-button" />
                     <ReactPlayer
                        url={
                           url && url.match(/webm$|ogv$|mp4$/g)
                              ? [{ src: `${url}`, type: "video/mp4" }]
                              : url
                        }
                        config={{
                           youtube: {
                             playerVars: { rel: 0 }
                           }
                        }}
                        playing={isVideoPoppedUp}
                        controls
                        className="react-player-popup"
                        preload
                        onClick={e => e.stopPropagation()}
                        width="85%"
                        height="85%"
                     />
                  </VideoPopUp>
               </VideoWrapper>
            )}

            {inline && (

               <VideoWrapper className="inlineVideo">

                  <Poster
                     onClick={this.clickAndPlay}
                     isPlaying={isInlineVideoOnTop}
                     className="inline-poster"
                     innerRef={isInViewport && playAuto ? this.viewportToPlay : null}>
                     <PlaySvg />
                     <Bg src={poster} alt="poster" />
                  </Poster>
                  <ReactPlayer
                     playing={isInlineVideoOnTop}
                     url={
                        url && url.match(/webm$|ogv$|mp4$/g) 
                           ? [{ src: `${url}`, type: "video/mp4" }]
                           : url
                     }
                     config={{
                        youtube: {
                          playerVars: { rel: 0 }
                        }
                     }}
                     isPlaying={isInlineVideoOnTop}
                     className={`react-player-inline ${isVimeo ? "vimeo" : ""}`}
                     controls
                     preload
                     width="100%"
                     height="100%"
                  />
               </VideoWrapper>
            )}
         </div>
      )
   }
}


const VideoWrapper = styled.div`
   width: 100%;
   height: 100%;

   &.inlineVideo{
   height:0;
   padding-bottom:56.25%
   }

   position: relative;
   iframe, embed{
      min-height: auto;

		}
   .react-player-popup {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
   }
   .react-player-inline {
      position: absolute;
      top: 0;
      left: 0;
      &.inlineVideo{
         width:100%;
         height:100%;
      }
   }

   &.inlineVideo{
      iframe {
         padding-bottom: 0;
      }
   }

   .vimeo {
      iframe {
         padding-bottom: 0;
      }
   }
`

const Poster = styled.div`
   position: relative;
   height: 100%;
   width: 100%;

   &.inline-poster{
   position:absolute;
   }

   /* border: 1px solid red; */
   cursor: pointer;
   visibility: ${props => (props.isPlaying ? "hidden" : "visible")};
   z-index: ${props => (props.isPlaying ? "-5" : "3")};

   svg {
      transition: all 0.3s ease-in-out;
      z-index:30;
   }

   &:hover > svg {
      opacity: 0.8;
   }
`

const Bg = styled.img`
   width: 100%;
   height: 100%;
`

const VideoPopUp = styled.div`
   position: fixed;
   visibility: ${props => (props.isVisible ? `visible` : `hidden`)};
   opacity: ${props => (props.isVisible ? `1` : `0`)};
   /* width:; */
   /* height: 100vh; */
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   background: rgba(5, 5, 5, 0.8);
   z-index: 110;
   transition: all 0.3s ease-in-out;

   .close-button {
      position: absolute;
      display: block;
      padding: 3rem;
      top: 1rem;
      right: 1rem;
      height: 25px;
      width: 25px;
      cursor: pointer;
      z-index: 1;

      &:before {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 25px;
         top: 12px;
         right: 0;
         background-color: rgb(255, 255, 255);
         transform: rotate(45deg);
      }

      &:after {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 25px;
         top: 12px;
         right: 0;
         background-color: rgb(255, 255, 255);
         transform: rotate(-45deg);
         cursor: pointer;
      }
   }

   iframe {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      height: 62vw;
      max-height: 90vh;
      width: 84vw;
      max-width: 84vw;
      padding: 0;
   }
`

const TextPoster = styled.p`
   cursor: pointer;
   border-bottom: 2px solid ${vars.colors.blank};
   display: inline-block;
   padding-bottom: 0 !important;
   margin-bottom: ${vars.padding.inner}rem;
`

export default Video



// WEBPACK FOOTER //
// ./src/components/video.js